import numeral  from 'numeral';

const FormattedNumber = ({ value, format }) =>
  numeral(value).format(format);

export default FormattedNumber;
